export default __webpack_public_path__ + "static/media/generation-solar-bg.301c7cbe.jpg";